import React, {PureComponent, Component} from 'react';
import PropTypes from 'prop-types';
import {HAS_TOUCH} from "../../constants/environment";
import {convertKataToRome} from "../../utils";

class Viewer extends PureComponent {
  static propTypes = {
    modelId: PropTypes.string,
    bodyTypeId: PropTypes.string,
    generationId: PropTypes.string,
    gradeId: PropTypes.string,
    colorId: PropTypes.string,
    accessoryIndexList: PropTypes.string,
  };
  static defaultProps = {
    modelId: null,
    bodyTypeId: null,
    generationId: null,
    gradeId: null,
    colorId: null,
    accessoryIndexList: null,
  };

  static CANVAS_WIDTH = 1300;
  static CANVAS_HEIGHT = 550;
  // static CANVAS_HEIGHT = 600;
  static ROTATION_SPEED = 3;
  static ROTATION_IMAGE_NUM = 24;
  static DEFAULT_ANGLE = 60;
  //static DEFAULT_ANGLE = 270;

  constructor(props) {
    super();
    this.props = props;
    //
    this.onRotate = false;
    this.angle = Viewer.DEFAULT_ANGLE;
    this.startX = 0;
    this.startY = 0;
    this.moveX = 0;
    this.isFirst = false;
    this.src = null;
    this.state = {
      loading: false
    };
    //
    this.intervalId = null;
    this.intervalId2 = null;
    //this.isFirstLoaded = true;
  }

  render() {
    const {
      modelId,
      bodyTypeId,
      generationId,
      gradeId,
      colorId,
      accessoryIndexList,
    } = this.props;
    //
    //this.traceProps();
    this.startX = 0;
    this.moveX = 0;
    //
    return (
      <div className="ExteriorView__viewer" ref="viewer">
        <canvas
          className="ExteriorView__viewer__canvas"
          width={Viewer.CANVAS_WIDTH}
          height={Viewer.CANVAS_HEIGHT}
          ref="canvas"
          onMouseDown={(e) => {
            this.mouseDownHandler(e.clientX);
            this.refs.canvas.classList.add('press');
          }}
          onMouseMove={(e) => {
            this.mouseMoveHandler(e.clientX);
          }}
          onMouseUp={(e) => {
            this.mouseUpHandler();
            this.refs.canvas.classList.remove('press');
          }}
          onMouseLeave={(e) => {
            if (this.onRotate) {
              this.mouseUpHandler();
              this.refs.canvas.classList.remove('press');
            }
          }}
        />
        <div style={{display: 'none'}} ref="stocker"/>
        <Preloader loading={this.state.loading}/>
        <div className="ExteriorView__viewer__attention">
          <span><span/>360°View</span>
        </div>
      </div>
    )
  }

  componentDidMount() {
    // console.log('componentDidMount');
    this.refs.viewer.classList.add('pre-loading');
    this.refs.viewer.classList.remove('mouse-move');
    // this.refs.viewer.classList.add('loading');
    if (this.state.loading === false) {
      this.setState({
        loading: true
      });
    }
    //
    if (this.intervalId2) clearInterval(this.intervalId2);
    this.intervalId2 = setTimeout(()=> {
      this.preLoadImages();
      // this.loadImages();
    }, 500);
    //
    if (HAS_TOUCH) {
      this.refs.canvas.addEventListener('touchstart', this.touchStartHandler, {passive: true});
    }
  }

  componentWillReceiveProps(nextProps) {
    // this.props = nextProps;
  }

  componentWillUpdate(prevProps, prevState) {
    // console.log('componentWillUpdate', this.props, prevProps);
    if (JSON.stringify(prevProps) === JSON.stringify(this.props)) return;
    // if (JSON.stringify(prevProps) == JSON.stringify(prevState)) return;
    this.refs.viewer.classList.add('pre-loading');
    this.refs.viewer.classList.remove('mouse-move');
    // this.refs.viewer.classList.add('loading');
    if (this.state.loading === false) {
      this.setState({
        loading: true
      });
    }
    //
    if (this.intervalId2) clearInterval(this.intervalId2);
    this.preLoadImages();
    // this.loadImages();
  }

  touchStartHandler = (e) => {
    this.startX = e.changedTouches[0].clientX;
    this.startY = e.changedTouches[0].clientY;
    this.isFirst = true;
    this.refs.viewer.classList.add('start');
    this.refs.viewer.classList.add('mouse-move');
    //
    //this.refs.canvas.addEventListener('touchmove', this.touchMoveHandler, {passive: false});
    this.refs.canvas.addEventListener('touchmove', this.touchMoveHandler);
    this.refs.canvas.addEventListener('touchend', this.touchEndHandler, {passive: true});
  };

  touchMoveHandler = (e) => {
    const clientX = e.changedTouches[0].clientX;
    const clientY = e.changedTouches[0].clientY;
    if (this.isFirst) {
      this.isFirst = false;
      const rot = Math.atan2(this.startY - clientY, this.startX - clientX) * 180 / Math.PI;
      if ((60 <= rot && rot <= 120) || (-120 <= rot && rot <= -60)) {
        this.refs.canvas.removeEventListener('touchmove', this.touchMoveHandler);
        this.refs.canvas.removeEventListener('touchend', this.touchEndHandler);
        return;
      }
    }

    // ローディング中はドラッグ出来なくする
    if (this.state.loading === true) return;

    //e.preventDefault();
    this.moveX = clientX - this.startX;
    this.drawImage(this.formatAngle(this.moveX + this.angle));
  };

  touchEndHandler = (e) => {
    this.angle = this.formatAngle(this.moveX + this.angle);
    this.refs.canvas.removeEventListener('touchmove', this.touchMoveHandler);
    this.refs.canvas.removeEventListener('touchend', this.touchEndHandler);
  };

  mouseDownHandler = (clientX) => {
    this.startX = clientX;
    this.onRotate = true;
    this.refs.viewer.classList.add('start');
    this.refs.viewer.classList.add('mouse-move');
  };

  mouseMoveHandler = (clientX) => {
    if (!this.onRotate) return;

    // ローディング中はドラッグ出来なくする
    if (this.state.loading === true) return;

    this.moveX = clientX - this.startX;
    this.drawImage(this.formatAngle((this.moveX / Viewer.ROTATION_SPEED) + this.angle));
  };

  mouseUpHandler = () => {
    this.angle = this.formatAngle((this.moveX / Viewer.ROTATION_SPEED) + this.angle);
    this.onRotate = false;
  };

  preLoadImages = () => {
    // console.log('preLoadImages');
    // console.log('angle', this.angle);
    // Canvasクリア
    this.clearImage();
    // 要素削除
    while (this.refs.stocker.firstChild) this.refs.stocker.removeChild(this.refs.stocker.firstChild);
    //
    const directory = this.getDirectory();
    // 1枚目ローディング
    const img = new Image();
    img.onload = () => {
      this.refs.stocker.appendChild(img);
      // console.log('loaded', img);
      setTimeout(() => {
        this.drawImage(this.angle);
        this.refs.viewer.classList.remove('pre-loading');
        this.refs.viewer.classList.add('stand-by');
        setTimeout(()=> {
          // 2枚目以降読み込み開始
          this.loadImages();
        }, 500)
      }, 500);
    };
    img.src = directory + this.getAngleToImageName(this.angle)
  };

  loadImages = () => {
    // console.log('loadImages');
    this.refs.viewer.classList.remove('stand-by');
    this.refs.viewer.classList.add('loading');
    // 要素削除
    while (this.refs.stocker.firstChild) this.refs.stocker.removeChild(this.refs.stocker.firstChild);
    //
    const directory = this.getDirectory();
    let loadedCount = 0;
    let count = 0;
    let i, max;
    for (i = 0, max = Viewer.ROTATION_IMAGE_NUM; i < max; i = i + 1) {
      const img = new Image();
      img.onload = () => {
        this.refs.stocker.appendChild(img);
        loadedCount += 1;
        // console.log('loadedCount', loadedCount);
        if (Viewer.ROTATION_IMAGE_NUM <= loadedCount) {
          // console.log('complete');
          setTimeout(() => {
            this.drawImage(this.angle);
            this.refs.viewer.classList.remove('loading');
            this.refs.viewer.classList.remove('mouse-move');
            if (this.state.loading === true) {
              this.setState({
                loading: false
              });
            }
          }, 500);
        }
      };
      setTimeout(()=> {
        img.src = directory + this.getAngleToImageName(count * (360 / Viewer.ROTATION_IMAGE_NUM))
        count += 1;
      }, 50 * i)
    }
  };

  drawImage = (angle) => {
    // console.log('drawImage', angle);
    const src = this.getDirectory() + this.getAngleToImageName(angle);
    if (src === this.src) return;
    this.src = src;
    const img = new Image();
    const ctx = this.refs.canvas.getContext('2d');
    img.onload = () => {
      ctx.clearRect(0, 0, Viewer.CANVAS_WIDTH, Viewer.CANVAS_HEIGHT);
      //ctx.drawImage(img, 0, 0);
      ctx.drawImage(img, 0, -50, Viewer.CANVAS_WIDTH, Viewer.CANVAS_HEIGHT + 50);
    };
    img.src = src;
  };

  clearImage = () => {
    const ctx = this.refs.canvas.getContext('2d');
    ctx.clearRect(0, 0, Viewer.CANVAS_WIDTH, Viewer.CANVAS_HEIGHT);
  };

  getDirectory = () => {
    let arr = [];
    if (this.props.accessoryIndexList && this.props.accessoryIndexList !== '') {
      arr = this.props.accessoryIndexList.split(',');
    }
    //let str = '/globalassets/assets/cars/' + this.props.modelId + '/' + this.props.bodyTypeId + '/' + this.props.generationId + '/' + this.props.gradeId + '/360/';
    //let str = '/assets-dev/assets/cars/' + this.props.modelId + '/' + this.props.bodyTypeId + '/' + this.props.generationId + '/' + this.props.gradeId + '/360/';
    let str = null;
    if (0 <= String(location.hostname).indexOf('localhost')) {
      str = '/assets-dev/assets/cars/' + this.props.modelId + '/' + this.props.bodyTypeId + '/' + this.props.generationId + '/' + convertKataToRome(this.props.gradeId) + '/360/';
    } else {
      str = '/globalassets/assets/cars/' + this.props.modelId + '/' + this.props.bodyTypeId + '/' + this.props.generationId + '/' + convertKataToRome(this.props.gradeId) + '/360/';
    }
    if (arr && Array.isArray(arr) && 1 <= arr.length) {
      str = str + 'accessories/' + this.props.colorId + '/';
      let i, max;
      for (i = 0, max = arr.length; i < max; i = i + 1) {
        if (i === 0) {
          str = str + 'a' + (Number(arr[i]) + 1);
        } else if (i === 1) {
          str = str + 'b' + (Number(arr[i]) + 1);
        } else if (i === 2) {
          str = str + 'c' + (Number(arr[i]) + 1);
        } else if (i === 3) {
          str = str + 'd' + (Number(arr[i]) + 1);
        }
      }
      str = str + '/';
    } else {
      str = str + 'cars/' + this.props.colorId + '/';
    }
    str = str.replace(/ /g, '-').replace(/%20/g, '-').toLowerCase();
    return str;
  };

  formatAngle = (angle) => {
    angle = angle % 360;
    if (angle < 0) {
      angle = 360 + angle;
    }
    return angle;
  };

  getAngleToImageName = (angle) => {
    angle = angle % 360;
    if (angle < 0) {
      angle = 360 + angle;
    }
    let count = Math.floor(angle / (360 / Viewer.ROTATION_IMAGE_NUM));
    return 'l_' + (Array(4).join('0') + count).slice(-4) + '.png';
  };

}

export default Viewer;

class Preloader extends PureComponent {

  static IMAGE_WIDTH = 150;
  static IMAGE_HEIGHT = 150;
  static ROW_MAX = 6;
  static TOTAL_FRAMES = 40;

  constructor(props) {
    super();
    this.props = props;
    this.intervalId = null;
    this.currentFrame = 0;
    this.state = {
      top: 0,
      left: 0,
      loading: false,
    }
  }

  render() {
    return (
      <div className="ExteriorView__viewer__preloader">
        <span>
          <span style={{backgroundPosition: this.state.left + 'px ' + this.state.top + 'px'}}/>
        </span>
      </div>
    )
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.loading === nextProps.loading) return;
    this.setState({
      loading: nextProps.loading,
    });
    if (nextProps.loading === true) {
      this.stopAnimation();
      this.initAnimation();
      this.startAnimation();
    }
  }

  componentWillUnmount() {
    this.stopAnimation();
  }

  initAnimation = ()=> {
    this.currentFrame = 0;
    this.setState({
      top: 0,
      left: 0,
    });
  };

  startAnimation = ()=> {
    this.intervalId = setInterval(() => {
      this.setState({
        top: -Math.floor(this.currentFrame / Preloader.ROW_MAX) * Preloader.IMAGE_HEIGHT,
        left: -(this.currentFrame % Preloader.ROW_MAX) * Preloader.IMAGE_WIDTH,
      });
      //
      this.currentFrame = this.currentFrame + 1;
      if (Preloader.TOTAL_FRAMES <= this.currentFrame) {
        this.currentFrame = 0;
      }
    }, 1000 / 30)
  };

  stopAnimation = ()=> {
    if (this.intervalId) clearInterval(this.intervalId);
  }

}



// WEBPACK FOOTER //
// ./src/containers/exterior-view/Viewer.jsx